import React, { Component } from "react";
import { OrbitSpinner } from 'react-epic-spinners'
import moment from "moment";

class CoreEngine extends Component {

    componentWillMount() {
        let isloggedin = sessionStorage.getItem('isloggedin');
        if(!isloggedin || isloggedin === "false"){
            this.props.history.push('/auth/login');
        }
    }

    putrowstatus(item){
        if(item.status === 0){
            return "Pending"
        }else if(item.status === 1){
            return "Activated"
        }
    }

    changeInput = (event, stateName) => {
        debugger
        if(!event){
            this.setState({ [stateName]: "" });
        }else
        if(event && event.target){
            this.setState({ [stateName]: event.target.value });
        }else if(event && event.length){
            this.setState({ [stateName]: event });
        }else{
            this.setState({ [stateName]: event.value }); // select input
        }
    };
    changeInputCheckbox = (event, stateName) => {
        debugger

       this.setState({ [stateName]: event.target.checked });

    };

    changeInputOne = (event, stateName) => {
        if(!event){
            this.setState({ [stateName]: "" });
        }else
        if(event && event.target){
            this.setState({ [stateName]: event.target.value });
        }else{
            this.setState({ [stateName]: event.value }); // select input
        }
    };


     convertToSlug(Text,slug='-'){
        return Text.trim()
            .toLowerCase()
            .replace(/[^\w ]+/g,'')
            .replace(/ +/g,slug)
            ;
    }
    createSelectValue(array,withslug=false){
        let data = [];
        array.map((item)=>{
            if(item.length<2){

            }else{
                if(withslug){
                    data.push({ value: this.convertToSlug(item,"xx"), label: item.trim() })
                }else{
                    data.push({ value: item.trim().toLowerCase(), label: item.trim().toLowerCase() })
                }
            }


        });
        return data;
    };

     formatDate =(date)=> {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }



    filterCaseInsensitive(filter, row) {
        const id = filter.pivotId || filter.id;
        return (
            row[id] !== undefined ?
                String(row[id].toString().toLowerCase()).includes(filter.value.toString().toLowerCase())
                :
                true
        );
    }

    renderDateFromTimeStamp(timestamp) {
        let moment = require('moment');
        const formatted = moment.unix(timestamp/1000).format("DD/MM/YYYY HH:mm");
        return <span>
            {formatted}
        </span>
    }

    processPhone(phone) {

        let newphone = phone;
        if(phone.length==10 && phone.toString().startsWith("0") ){
            const withoutFirst = phone.slice(1);
            phone=withoutFirst;
        }

        if(phone.length==9){
            newphone = "+966"+phone
        }else if(phone.length==12){
            newphone = "+"+phone
        }

        return newphone
    }
    renderDate(item) {

        if(!item){
            return "-"
        }
        let moment = require('moment');

        let obj = moment(item).utcOffset(item).add("hour",3)

        const newdate = obj.format('DD/MM/YYYY HH:mm')
       // const newdate = obj.format('DD/MM/YYYY ')
        return newdate.toString()
    }

    renderDateOnly(item) {

        if(!item){
            return "-"
        }
        let moment = require('moment');

        let obj = moment(item).utcOffset(item).add("hour",3)

        const newdate = obj.format('DD/MM/YYYY')
        // const newdate = obj.format('DD/MM/YYYY ')
        return newdate.toString()
    }

    renderProgress() {
        return (
            <div className="content">
                <div className="col-md-2 ml-auto mr-auto">

                    <div className="logo">

                        <div className="logo-img">
                            <OrbitSpinner color="#51BCDA"  className="loadingLogo" />
                        </div>

                    </div>

                </div>
            </div>
        )
    }

}

export default CoreEngine;


